/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.ExamAttemptService
 */

export const startRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExamAttemptService',
  rpcName: 'start',
  auth: 'app',
  fingerprint: 'dq9QgnbZPR-HT0hqxW_yGWam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resumeRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExamAttemptService',
  rpcName: 'resume',
  auth: 'app',
  fingerprint: '50WCpNeJzWSHT0hqxW_yGWam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const submitQuestionRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExamAttemptService',
  rpcName: 'submitQuestion',
  auth: 'app',
  fingerprint: 'ExVolDoVKinOuBvFDwBEImam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.ExamAttemptService',
  rpcName: 'validate',
  auth: 'app',
  fingerprint: 'G40PvxMSKPWHT0hqxW_yGWam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};